import React from "react";
import { SimpleHeader } from "./SimpleHeader";

interface BookkeepingHeaderProps {
  bookkeeping: server.dto.Bookkeeping
}

export const BookkeepingHeader = ({ bookkeeping }: BookkeepingHeaderProps) =>
  <SimpleHeader title={bookkeeping.name} isDeleted={false}>
    <div className="purple-header-text">{bookkeeping.code}</div>
  </SimpleHeader>;
